import React, { Component } from 'react'
import StatusList from 'src/components/arrival-status-list-component/status-list-component';
// images
const customer_bags = require('../../images/preslot_inbound_header.svg');
const bags_in_storage = require('../../images/progress_header_2.svg');
const bags_in_van = require('../../images/progress_header_1.svg');
// styles
const styles = require('./ccd-bags-proccessing.scss');

export enum BagsJourneyType {
  Collected = 1,
  InTransit = 2,
  InStorage = 3,
  OutOfStorage = 4,
  CheckedIn = 5,
  Downgraded = 6,
  WithCourier = 7,
  Delivered = 8,
  NotCollected = 9
}

export enum BagsJourneyStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  UrgentAttention = 4,
  PartiallyCompleted = 5
}

interface IProps {
  trackingData: any;
  language: string;
  multiLang: any;
}

const IMAGE_MAP = {
  Collected: customer_bags,
  InTransit: customer_bags,
  InStorage: bags_in_storage,
  OutOfStorage: bags_in_storage,
  CheckedIn: customer_bags,
  Downgraded: customer_bags,
  WithCourier: bags_in_van
}

export class ArrivalBagsProcessingComponent extends Component<IProps, any> {
  render() {
    const { language, multiLang, trackingData } = this.props;
    const { processTrackingStatus, bagsJourney } = trackingData;
    const title = multiLang[processTrackingStatus.titleDisplay + language] || processTrackingStatus.titleDisplay;
    const subtitle = multiLang[processTrackingStatus.subTitle + language] || processTrackingStatus.subTitle;
    const text = isNaN(processTrackingStatus?.text[0]) ? processTrackingStatus?.text : processTrackingStatus?.text[0] === '1' ? processTrackingStatus?.text : '%s' + processTrackingStatus?.text.substr(1)
    const description = multiLang[text + language]?.replace('%s', processTrackingStatus?.text[0]) || processTrackingStatus.text;
    const CurrentStep = bagsJourney.filter((i) => {
      if ((i.bagsJourneyStatus === 3)) {
        return i.bagsJourneyType
      }
    });

    const imgeSource = IMAGE_MAP[BagsJourneyType[CurrentStep[CurrentStep.length - 1]?.bagsJourneyType]];
    const warningMessage = multiLang['Bags collected from carousel' + language];
    const showWarningMessage = bagsJourney.find(job => job.bagsJourneyStatus === BagsJourneyStatus.UrgentAttention || job.bagsJourneyStatus === BagsJourneyStatus.PartiallyCompleted);
    const supportLink = {
      '': 'https://support.airportr.com/hc/en-us/articles/4403885089169-Arrivals-What-if-my-bag-isn-t-on-the-baggage-reclaim-at-my-destination',
      '_fr': 'https://support.airportr.com/hc/de/articles/4403885089169-Was-ist-wenn-mein-Gep%C3%A4ck-an-meinem-Zielort-nicht-auf-der-Gep%C3%A4ckausgabe-steht',
      '_de': 'https://support.airportr.com/hc/de/articles/4403885089169-Was-ist-wenn-mein-Gep%C3%A4ck-an-meinem-Zielort-nicht-auf-der-Gep%C3%A4ckausgabe-steht'
    };
    return (
      <div className={styles.mainContent}>
        <div className={styles.sectionWrapper}>
          <div className={styles.section}>
            <div className={styles.card}>
              <div className={styles.cardBody}>
                <h1 className={styles.heading}>{title}</h1>

                <div className={styles.group}>
                  <div>
                    <img src={imgeSource ? imgeSource : customer_bags} />
                    <h3 className={styles.subHeading}>
                      {subtitle}
                    </h3>
                    {showWarningMessage && warningMessage && <p className={[styles.warning, styles.description, styles.mb_12].join(' ')}>
                      {processTrackingStatus.collectedBagCount + '/' + processTrackingStatus.bookedBagCount + ' ' + warningMessage}
                    </p>}
                    <p className={styles.description}>
                      {description}
                    </p>
                    {bagsJourney.find(a => a.bagsJourneyType === BagsJourneyType.NotCollected) && <p className={[styles.description, styles.mt_12].join(' ')}>
                      <a target='_blank' href={supportLink[language]}>{multiLang['How do I find my missing bag?' + language]}</a>
                    </p>}
                  </div>

                  <div>
                    <StatusList
                      bagsJourney={bagsJourney}
                      multiLang={multiLang}
                      language={language}
                      processTrackingStatus={processTrackingStatus}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ArrivalBagsProcessingComponent



// WEBPACK FOOTER //
// ./src/containers/ccd-bags-proccessing/ccd-bags-proccessing.component.tsx